module.exports = __webpack_public_path__ + "img/image.4ea175b7.svg";